import { gql } from 'graphql.macro';
import { searchFragment } from 'apollo/fragments';

export const getSearchTemplate = gql`
    query search($searchString: SearchString!) {
        search(searchString: $searchString) {
            ...searchFields
        }
    }
    ${searchFragment}
`;
